import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useCommonInits } from 'hooks/useCommonInits';
import { getLocalInterval, INTERVAL_KEY } from 'utils/time';
import {
    getTimeAttributes,
    initiateInterval,
    setAppInterval,
} from 'redux/time/timeSlice';

const Dashboard = () => {
    const { navigate, dispatch, location, params } = useCommonInits();

    const { home, dashboardEdited, dashbord, newDashboard } = useSelector(
        state => state.dashboard,
    );

    const { interval, intervalId } = useSelector(getTimeAttributes);

    const clearOldInterval = () => {
        const storedInterval = getLocalInterval();
        if (storedInterval?.id) {
            localStorage.setItem(
                INTERVAL_KEY,
                JSON.stringify({ interval: storedInterval.interval }),
            );

            clearInterval(storedInterval?.id);
            dispatch(
                setAppInterval({
                    interval: 0,
                    intervalCount: 0,
                    intervalId: null,
                }),
            );
        }
    };

    const setNewInterval = newInterval => {
        if (newInterval) {
            const newIntervalId = setInterval(() => {
                dispatch(initiateInterval());
            }, newInterval);
            localStorage.setItem(
                INTERVAL_KEY,
                JSON.stringify({
                    interval: newInterval,
                    id: newIntervalId,
                }),
            );
            dispatch(
                setAppInterval({
                    interval: newInterval,
                    intervalId: newIntervalId,
                }),
            );
        }
    };

    useEffect(() => {
        const storedInterval = getLocalInterval();
        if (!intervalId && !storedInterval?.id && storedInterval?.interval) {
            setNewInterval(storedInterval.interval);
        }

        return () => {
            clearOldInterval();
        };
    }, []);

    // useEffect(() => {
    //     if (newDashboard?._id && isNewDashboard(location.pathname)) {
    //         const id = newDashboard._id;
    //         navigate(`/${ROUTE_PATHS.dashboard}/${id}`);
    //         dispatch(resetNewDashboard());
    //     }
    // }, [newDashboard]);

    // useEffect(() => {
    //     if (
    //         isNewDashboard(location.pathname) &&
    //         !newDashboard?.dashboard_type
    //     ) {
    //         dispatch(createNewDashboard());
    //     } else if (!home && !isNewDashboard(location.pathname) && !params.id) {
    //         dispatch(homePageAsync());
    //     }

    //     if (params.id && params.id !== 'new' && !dashboardEdited) {
    //         dispatch(getDashbordById(params.id));
    //     }
    // }, [location]);

    // if (newDashboard?.isNew && !newDashboard?.dashboard_type) {
    //     return <DashboardType />;
    // } else if (newDashboard?.isNew && newDashboard?.dashboard_type) {
    //     return <Dashboards type={newDashboard.dashboard_type} />;
    // } else {
    //     return <Dashboards type={dashbord?.dashboard_type} />;
    // }
};

export default Dashboard;
